export class Player {
    constructor(public time: string, public score: number, public name: string, public total: number) {}
}